// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__oOOEW","dark":"Preloader_dark__9FrGX","preloader-button":"Preloader_preloader-button__iL-39"};